import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { Nav4ITAMMenuLinkItem } from './Nav4ITAMMenuLinkItem.tsx';

export const PACKAGE_NAME = 'jiraItamNav4MenuItem';
export const TEAM_NAME = 'Aurum';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const Nav4ITAM = (props: Props): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-itam">
		<JSErrorBoundary
			fallback="flag"
			id="itam-section"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Nav4ITAMMenuLinkItem {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
